export enum POLICY_DOC_ACTION_TYPE {
  CREATED = 'created',
  DELETED = 'deleted',
  MODIFIED = 'modified',
  SIGNED = 'signed',
  ACK = 'acknowledge',
}
